import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import type { ComponentProps } from 'react';

/**
 * Toolbar glyph for the "create barrier" tool, mirroring the map icon
 * used for placed barriers (Russian road sign 3.1 "Въезд запрещён").
 * Colours are fixed so the glyph reads the same on both the primary
 * (active) and default button backgrounds — AntD's `currentColor`
 * contract doesn't fit a two-colour sign.
 */
function BarrierSvg(props: Partial<CustomIconComponentProps>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <circle cx="16" cy="16" r="13.5" fill="#d4181d" />
      <rect x="6" y="13" width="20" height="6" fill="#ffffff" />
    </svg>
  );
}

export default function BarrierGlyph(props: ComponentProps<typeof Icon>) {
  return <Icon component={BarrierSvg} {...props} />;
}
